import { render, staticRenderFns } from "./ShowroomWsTextChip001.vue?vue&type=template&id=0fa6d11a"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports